module.exports = __webpack_public_path__ + "static/media/day.5a826919.svg";